import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type ProfileQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input']
}>

export type ProfileQuery = {
	__typename?: 'Query'
	profile: {
		__typename: 'UserProfile'
		id: string
		username: string
		currentProfilePictureUrl: string
		currentName: string
		bio: string
		instagramUsername: string
		tiktokUsername: string
		youtubeUsername: string
		twitterUsername: string
		websiteUrl: string
		isCurrentUser: boolean
		hasStore: boolean
		publishedListings: Array<{
			__typename: 'Listing'
			id: string
			isPublished: boolean
			rank: number
			title?: string | null
			description?: string | null
			basePrice?: number | null
			currency: string
			viewsCount: number
			thankYouMessage?: string | null
			suggestedPrice?: number | null
			avgRating: number
			numReviews: number
			currentTrip: {
				__typename: 'Trip'
				id: string
				title?: string | null
				description?: string | null
				departAt?: string | null
				returnAt?: string | null
				isOwner: boolean
				isIndestructible: boolean
				numDestinations: number
				numBlocks: number
				numSources: number
				numHighlights: number
				isPurchased: boolean
				weekendCostRangeUpper?: number | null
				weekendCostRangeLower?: number | null
				weekCostRangeUpper?: number | null
				weekCostRangeLower?: number | null
				monthCostRangeUpper?: number | null
				monthCostRangeLower?: number | null
				categories?: Array<string> | null
				owner?: {
					__typename: 'User'
					id: string
					email: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				} | null
				unpublishedListing?: {
					__typename: 'Listing'
					id: string
					isPublished: boolean
					rank: number
					title?: string | null
					description?: string | null
					basePrice?: number | null
					currency: string
					viewsCount: number
					thankYouMessage?: string | null
					suggestedPrice?: number | null
					avgRating: number
					numReviews: number
					owner: {
						__typename: 'User'
						id: string
						bio?: string | null
						instagramUsername?: string | null
						tiktokUsername?: string | null
						username?: string | null
						currentName: string
						currentProfilePictureUrl: string
					}
					reviews?: Array<{
						__typename: 'Review'
						id: string
						starRating: number
						feedbackToCreator?: string | null
						comment?: string | null
						createdAt: string
						reviewer: {
							__typename: 'User'
							id: string
							username?: string | null
							currentName: string
							currentProfilePictureUrl: string
						}
					}> | null
				} | null
				featuredHighlights: Array<{
					__typename: 'Block'
					featuredImagePosition?: number | null
					id: string
					title?: string | null
					description?: string | null
					position: number
					parentId?: string | null
					blockType: Types.BlockType
					createdAt: string
					icon: Types.CustomIcon
					color: Types.CustomColor
					highlightPosition: number
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
					parentBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
						position: number
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
					} | null
					parentDestination?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						blockType: Types.BlockType
						position: number
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
				} | null>
				yourPurchase?: {
					__typename: 'Purchase'
					id: string
					review?: { __typename: 'Review'; id: string } | null
				} | null
			}
			owner: {
				__typename: 'User'
				id: string
				bio?: string | null
				instagramUsername?: string | null
				tiktokUsername?: string | null
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
			}
			reviews?: Array<{
				__typename: 'Review'
				id: string
				starRating: number
				feedbackToCreator?: string | null
				comment?: string | null
				createdAt: string
				reviewer: {
					__typename: 'User'
					id: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
			}> | null
		} | null>
	}
}

export const ProfileDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Profile' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'profile' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProfileFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProfileFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserProfile' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'youtubeUsername' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'twitterUsername' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isCurrentUser' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasStore' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'publishedListings' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'currentTrip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripsFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripsFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'categories' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicUserFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'featuredHighlights' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HighlightBlockFields' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'featuredImagePosition' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'yourPurchase' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'review' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicUserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'highlightPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
	],
} as unknown as DocumentNode
